'use client';

import React from 'react';
import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import Image from 'next/image';
import { signOut, useSession } from 'next-auth/react';
import { usePathname } from 'next/navigation';
import { cn } from '@/helpers/common';
import HeaderDropdownKD from './HeaderDropdownKD';

const desktopLinkCn =
  'text-sm font-semibold text-kd-mako px-3 py-2 rounded-[20px] no-underline default-transition bg-white hover:bg-kd-athens-gray';

const HeaderKD = () => {
  const pathname = usePathname();
  const { data: value } = useSession();
  const session = value;

  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 border-b border-kd-geyser bg-white">
      <div className="max-w-290 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="Koch Davis home">
          <Image
            width="160"
            height="38"
            src="https://assets.kochdavisjobs.com/kd/logo-2026-black.png"
            alt="Koch Davis"
            unoptimized
            priority
          />
        </Link>
        <nav aria-label="Main" className="md:flex max-md:hidden items-center gap-3">
          <a
            aria-current={pathname === ROUTES.jobs ? 'page' : undefined}
            className={cn(desktopLinkCn, {
              'text-kd-persimmon bg-kd-persimmon12': pathname === ROUTES.jobs,
            })}
            href={ROUTES.jobs}
          >
            All Jobs
          </a>
          <a
            aria-current={pathname === ROUTES.partners ? 'page' : undefined}
            className={cn(desktopLinkCn, {
              'text-kd-persimmon bg-kd-persimmon12': pathname === ROUTES.partners,
            })}
            href={ROUTES.partners}
          >
            For employers
          </a>
          <div className="w-px h-4 bg-kd-geyser" />
          {session ? (
            <>
              <a
                aria-current={pathname === ROUTES.profile ? 'page' : undefined}
                className={cn(desktopLinkCn, {
                  'text-kd-persimmon bg-kd-persimmon12':
                    pathname === ROUTES.profile || pathname === ROUTES.history,
                })}
                href={ROUTES.profile}
              >
                My search
              </a>
              <button className={desktopLinkCn} onClick={() => signOut()}>
                Sign out
              </button>
            </>
          ) : (
            <a
              className={
                'text-sm font-semibold text-white px-3 py-2 rounded-[20px] no-underline default-transition bg-kd-persimmon hover:bg-kd-valencia'
              }
              href={pathname === ROUTES.signin ? ROUTES.signup : ROUTES.signin}
            >
              {pathname === ROUTES.signin ? 'Sign up' : 'Sign in'}
            </a>
          )}
        </nav>
        <div className="md:hidden max-md:block">
          <HeaderDropdownKD session={session} isSighInPath={pathname === ROUTES.signin} />
        </div>
      </div>
    </header>
  );
};

export default HeaderKD;
